"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddNewController = function AddNewController(LanguageFactory, growl, Information, Util) {
  "ngInject";

  (0, _classCallCheck3.default)(this, AddNewController);
  var vm = this;
  vm.newItem = null;
  vm.language = "IT";
  vm.summernoteOptions = Util.getSummernoteOptions();

  vm.saveNewItem = saveNewItem;

  init();

  function init() {
    vm.newItem = {
      information: {
        active: true
      },
      informationStringsList: []
    };

    _lodash2.default.each(LanguageFactory.getAvailableLanguageKeys(), function (l) {
      vm.newItem.informationStringsList.push({
        title: "",
        body: "",
        language: l
      });
    });
  }

  function saveNewItem(itemToSave) {
    Information.post(itemToSave).then(function (res) {
      growl.success("Sezione aggiunta con successo");
      vm.close();
    }, function (err) {
      growl.error("Errore salvataggio sezione");
    });
  }
};

exports.default = AddNewController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/addNew/addNew.controller.js